import "../common/template/dependencies";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import App from "./app";
import Auth from "../auth/auth";
import "./authOrApp.css";
import { validateToken } from "../auth/authActions";
import consts from "../consts";

class AuthOrApp extends Component {
    state = {
        subscricaoPush: null,
        isIos: false,
        isAndroid: false,
        isInstalled: false, // Estado para verificar se o app está instalado
        showInstallPrompt: false,
        deferredPrompt: null,
        showIosMessage: true, // Exibe a mensagem no iOS
    };

    //verifica se o dispositivo está instalado
    checkInstallationStatus() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isIos = userAgent.includes("iphone") || userAgent.includes("ipod");
        const isAndroid = userAgent.includes("android");

        const isInstalled = isIos
            ? window.navigator.standalone || window.matchMedia("(display-mode: standalone)").matches
            : isAndroid
            ? window.matchMedia("(display-mode: standalone)").matches
            : false;

        this.setState({ isIos, isAndroid, isInstalled });
    }

    componentDidMount() {
        this.checkInstallationStatus();

        // Verifica o suporte ao Service Worker
        if ("serviceWorker" in navigator) {
            // console.log("Service Worker está disponível", navigator.serviceWorker);
            if ("BeforeInstallPromptEvent" in window) {
                console.log("BeforeInstallPromptEvent está disponível no window");
                window.addEventListener("beforeinstallprompt", (e) => {
                    e.preventDefault(); // Previne o prompt automático
                    this.setState({ deferredPrompt: e, showInstallPrompt: true });
                });
            }
        } else {
            console.log("Service Worker não está disponível neste navegador.");
        }

        if (this.props.auth.usuario) {
            this.props.validateToken({ token: this.props.auth.usuario.token });
        }
    }

    // Função para exibir o prompt de instalação no Android
    handleInstallClick = () => {
        const { deferredPrompt } = this.state;
        if (deferredPrompt) {
            deferredPrompt.prompt(); // Exibe o prompt
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("Usuário aceitou o prompt de instalação");
                } else {
                    console.log("Usuário rejeitou o prompt de instalação");
                }
                this.setState({ deferredPrompt: null, showInstallPrompt: false });
            });
        }
    };

    // Função para fechar a mensagem no iOS
    handleCloseIosMessage = () => {
        this.setState({ showIosMessage: false });
    };

    async registerPush(id_usuario) {
        if ("serviceWorker" in navigator && "PushManager" in window) {
            try {
                const registration = await navigator.serviceWorker.register("/push-sw.js");
                const sub = await registration.pushManager.getSubscription();
                if (sub) sub.unsubscribe(); // remove subscription antiga

                //buscaChavePública
                const chavePublicaVAPID = (
                    await axios.get(`${consts.API_URL}/notificacao/chave`, {
                        responseType: "arraybuffer",
                    })
                ).data;

                const newSub = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: new Uint8Array(chavePublicaVAPID),
                });
                this.setState({ ...this.state, subscricaoPush: newSub });

                await axios.post(`${consts.API_URL}/registerSubscription`, {
                    id_usuario,
                    subscription: newSub,
                });
            } catch (erro) {
                console.error(erro);
            }
        }
    }

    async unregisterPush(id_usuario) {
        console.log("unregisterPush", { sub: this.subscription });
        try {
            if (this.state.subscricaoPush) {
                await this.state.subscricaoPush.unsubscribe();
                await axios.post(`${consts.API_URL}/unregisterSubscription`, {
                    id_usuario,
                });
                this.setState({ ...this.state, subscricaoPush: null });
            }
        } catch (erro) {
            console.error(erro);
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.auth.usuarioLogado && (prevProps.auth.usuarioLogado || {}).id !== this.props.auth.usuarioLogado.id) {
            this.registerPush(this.props.auth.usuarioLogado.id);
        }

        // Quando o usuário desloga
        if (!this.props.auth.usuarioLogado && prevProps.auth.usuarioLogado) {
            this.unregisterPush(prevProps.auth.usuarioLogado.id);
        }
    }

    render() {
        const { usuario, validToken } = this.props.auth;
        const { isIos, isAndroid, isInstalled, showInstallPrompt, showIosMessage } = this.state;
        if (usuario && validToken) axios.defaults.headers.common["authorization"] = usuario.token;

        return (
            <>
                {/* Exibe a mensagem de instrução no iOS apenas se o app não estiver instalado */}
                {isIos && !isInstalled && showIosMessage && (
                    <div className="install-banner">
                        <p>Para instalar, adicione à sua tela inicial no Safari!</p>
                        <p>Abra o menu de compartilhamento e selecione "Adicionar à Tela de Início".</p>
                        {/* Botão OK para fechar a mensagem */}
                        <button className="btn-install-ok" onClick={this.handleCloseIosMessage}>
                            Entendi
                        </button>
                    </div>
                )}

                {/* Exibe a mensagem de instrução no Android caso o app não esteja instalado */}
                {isAndroid && !isInstalled && showInstallPrompt && (
                    <div className="install-banner py-3">
                        <button className="btn-install-ok" onClick={this.handleInstallClick}>
                            Instalar Gradios
                        </button>
                        <button className="btn-install-cancel" onClick={() => this.setState({ showInstallPrompt: false })}>
                            Agora não
                        </button>
                    </div>
                )}

                {usuario && validToken ? <App>{this.props.children}</App> : <Auth />}
            </>
        );
    }
}

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = (dispatch) => bindActionCreators({ validateToken }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(AuthOrApp);
